// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oLB-","fullView":"styles_fullView__3R1zk"};